export default (obj: object, path: string, defaultValue?: any): any =>
  path
    .replace(/\[/g, '.')
    .replace(/]/g, '')
    .split('.')
    .reduce(
      (a: any[], c: any) => (a && a[c] ? a[c] : defaultValue),
      obj as any[]
    );
